<template>
  <div class="side-bar">
    <a-menu mode="inline" style="width: 180px;" @click="handleClick" :openKeys="openKeys" @openChange="onOpenChange" :selectedKeys="selectedKeys">
      <template v-for="o in menuList">
        <a-sub-menu :key="o.id">
          <span slot="title">{{o.title}}</span>
          <a-menu-item v-for="cItem in o.children"  :key="cItem.id" :title="cItem.title">{{cItem.title}}</a-menu-item>
        </a-sub-menu>
      </template>
    </a-menu>
  </div>
</template>
<script>
import {Menu} from 'ant-design-vue'
import { mapState,mapActions } from 'vuex'

  export default {
    components:{
      'a-menu':Menu,
      'a-sub-menu':Menu.SubMenu,
      'a-menu-item':Menu.Item
    },
    created() {
      this.getMenus()
    },
    computed: {
      ...mapState('adwords',['menuList', 'linkCargoryId', 'openKeys']),
      selectedKeys() {
        return [this.linkCargoryId]
      }
    },
    methods: {
      ...mapActions('adwords',['getCategoryTreeData']),
      handleClick({item, key, keyPath}) {
        if (keyPath.length == 1) { this.onOpenChange([]) }
        this.$store.commit('adwords/setMutations', {data:key,nameSpace:'linkCargoryId'})
        this.$store.commit('adwords/setMutations', {data:item.title,nameSpace:'linkTitle'})
        if (this.$route.name != 'adwordsSearch') {
          this.$router.push({name:'adwordsSearch'})
        }
        this.$store.commit('adwords/setMutations', {data:'',nameSpace:'searchWord'})
        this.$store.commit('adwords/setMutations', {data:1,nameSpace:'page'})
      },
      async getMenus() {
        await this.getCategoryTreeData()
      },
      onOpenChange(openKeys) {
        this.$store.commit('adwords/setMutations', {data:openKeys.length > 1 ? [openKeys[1]] : openKeys[0] ? [openKeys[0]] : [],nameSpace:'openKeys'})
      }
    }
  };
</script>

<style lang="scss" scoped>
.side-bar {
  background-color: #fff;
  flex: 1 1 auto;
  .ant-menu {
    border:0;
  }
}
.side-bar {
  .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
    width: 10px;
    height: 10px;
    right: 20px;
    background: url('~@assets/images/down_arr.png') no-repeat;
    background-size: 100% auto;
    background-position: center center;
    transform: translateY(-50%);
    &:before,&:after {
      width: 0; 
    }
  }
  .ant-menu-submenu-open.ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow  {
    background-image: url('~@assets/images/up_arr.png');
  }
  .ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
    text-align: left;
    padding-left: 20px;
    margin: 0;
  }
  .ant-menu-inline .ant-menu-submenu.ant-menu-submenu-open {
    color: #333;
    
    >.ant-menu-submenu-title {
      font-weight: bold;
      color: #1C7AE5;
    }
  }
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background: #DFF1FF;
    font-size: 14px;
    color: #116CD0;
  }
  .ant-menu-item {
    &:after {
      border: 0;
    }
  }
}
</style>

